<template>
  <a-modal
    :visible="visible"
    centered
    title="Tasks"
    @cancel="closeModal"
    :width="750"
  >
    <XTable
      class="mt-3"
      :model="model"
      ref="tasks"
      :options="{noContent: 'No tasks', is_row_selection: false, is_load_req: false}"
      :search="false"
      :is_show_icon="false"
      :is_pagenation="false"
    >
      <span slot="title" slot-scope="text,record,index">
        <a-popover v-if="text.record && text.record.title">
          <template slot="content">
            <p>{{ text.record.title }}</p>
          </template>
          <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 10rem; text-align: left;">
            {{ text.record.title }}
          </p>
        </a-popover>
      </span>
      <span slot="status" slot-scope="text,record,index">
        <a-button
          size="default"
          ghost
          :style="styleStatusTask(text.record.status)"
        >
          {{ currentTaskStatus(text.record.status) }}
        </a-button>
      </span>
      <span slot="priority" slot-scope="text,record">
        <template v-if="text.record.priority === 1">Low</template>
        <template v-else-if="text.record.priority === 2">Normal</template>
        <template v-else>High</template>
      </span>
      <span slot="assigned" slot-scope="text,record" v-if="text.record.assigned_user">
        {{ text.record.assigned_user.first_name }} {{ text.record.assigned_user.last_name }}
      </span>
      <span slot="time" slot-scope="text,record" v-if="text.record.time_estimate">
        {{ text.record.time_estimate + "h" }}
      </span>
      <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
        <a-popover v-if="text.record && text.record.title">
          <template slot="content">
            <p>{{ text.record.matter.title }}</p>
          </template>
          <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 10rem; text-align: left;">
            {{ text.record.matter.title }}
          </p>
        </a-popover>
      </span>
      <span slot="task_type" slot-scope="text,record" v-if="text.record.task_type">
        {{ text.record.task_type.title }}
      </span>
      <span slot="contact" slot-scope="text,record" v-if="text.record.matter">
        <template v-if="text.record.matter.client">
          <template v-if="text.record.matter.client.person">
            {{ text.record.matter.client.person.first_name }} {{ text.record.matter.client.person.last_name }}
          </template>
          <template v-else>
            {{ text.record.matter.client.company.name }}
          </template>
        </template>
      </span>
      <span slot="due_date" slot-scope="text,record">
        {{ setDateFormat(text.record.due_date) }}
      </span>
    </XTable>
  </a-modal>
</template>

<script>
import axios from "@/axios"
import moment from 'moment'
import XTable from '../../components/x-table/XTable'
import * as TableCol from './taskTbl.js'
import mixin from '../mixin/mixin'

export default {
  name: 'TaskListModal',

  components: {
    XTable,
  },

  mixins: [mixin],

  props: {
    // The v-model controls the visibility of the modal.
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    date: {
      type: String,
      required: false,
      default: () => moment(new Date().toISOString()).startOf('month').format('YYYY-MM-DD[T]HH:mm:ss')
    },
  },

  data() {
    return {
      // Whether the modal is visible or not.
      // It is the mutable backup for props.value.
      visible   : false,
      model     : null,
    }
  },

  watch: {
    value: function(val) {
      if (val) this.openModal()
      else this.closeModal()
    },
  },

  mounted() {
    this.model = TableCol.default
    this.fetchTable()
  },

  methods: {
    openModal() {
      // TODO: Check for permissions...
      this.visible = true
      this.$nextTick(() => {
        this.fetchTable()
      })
    },

    closeModal() {
      this.visible = false
      this.$emit('input', false)
    },

    async fetchTable() {
      if (!this.$refs.tasks.query) this.$refs.tasks.query = {}
      this.$refs.tasks.query.query = [{
        field: 'due_date',
        condition:'=',
        value: this.date
      }]
      await this.$refs.tasks.fetch()
    },

    currentTaskStatus(sts){
      if (sts === 1) return 'Pending'
      if (sts === 2) return 'In progress'
      if (sts === 3) return 'In review'
      if (sts === 4) return 'Complete'
    },

    styleStatusTask(sts){
      if (sts === 1) return { borderColor: '#1890ff', color: '#1890ff' }
      if (sts === 2) return { borderColor: '#fa8c16', color: '#fa8c16' }
      if (sts === 3) return { borderColor: '#722ed1', color: '#722ed1' }
      if (sts === 4) return { borderColor: '#52c41a', color: '#52c41a' }
    },
  },
}
</script>
